<template>
    <div class="col-md-8 pb-4">
        <h4 class="pb-2">{{ trans('community.profile-edit.public_profile') }}</h4>
        <b-card class="shadowed mb-4 pt-2 pl-2 pr-2">
            <div class="d-flex justify-content-end">
                <privacy-alert
                    buttonSize="sm"
                    :popupContent="trans('legend.lifeed')"
                    :popupButton="trans('global.more_info')"
                    :popupHref="{name: 'privacy-legend'}"
                    popoverId="privacyPopover"
                    v-bind:targetBlank="true"
                >
                    <img src="/images/icon_public.svg" width="24px" class="pr-1" /> {{ trans('global.lifeed') }}
                </privacy-alert>
            </div>
            <h6>{{ trans('community.profile-edit.avatar') }}</h6>
            <profile-photo
                :isCurrentUser="isCurrentUser"
                :userAvatar="userProfileInfo.otherUser ? userProfileInfo.otherUser.avatar : userAvatar"
                :userInfo="userProfileInfo.userInfo"
                @onUploadImage="onUploadImage"
                @onDeleteImage="onDeleteImage"
            />
            <div class="text-primary h5 text-center">
                {{userProfileInfo.userInfo ? userProfileInfo.userInfo.displayName : ''}}
            </div>
            <div class="d-flex flex-row justify-content-center mb-4">
                <profile-counter v-for="(counter, c) in userProfileInfo.counters"
                    :key="`counter-${c}`"
                    :count="counter.count"
                    :label="counter.label"
                />
            </div>
            <div class="d-flex justify-content-end">
                <b-button variant="light" class="secondary mt-3" :to="myPublicProfileRoute">{{ trans('community.profile-edit.check_profile') }}</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
    import ProfilePhoto from "../../molecules/ProfilePhoto"
    import ProfileCounter from "../../atoms/ProfileCounter"
    import { mapMutations, mapGetters, mapActions } from "vuex"
    import PrivacyAlert from "../../molecules/PrivacyAlert"
    import { USER_PUBLIC_PROFILE } from "../../paths.js"

    export default {
        components: { ProfilePhoto, ProfileCounter, PrivacyAlert },
        name: "UserProfile",
        props: {
            currentUserId: Number
        },
        methods: {
            ...mapMutations('profile', [
                'addToast',
                'addErrorToast',
                'addValidationErrorToast'
            ]),
             ...mapActions({
                setUserAvatar: 'user/userAvatar'
            }),
            onUploadImage(e) {
                let image = e.target.files[0];
                let formData = new FormData();
                formData.append('avatar', image);

                this.$axios.post('/api/rest/profile/user/store-avatar', formData)
                    .then(() => {
                        this.addToast({
                            message: 'Profile Updated!',
                            title: 'Success',
                            variant: 'success'
                        });
                        let reader = new FileReader();
                        reader.readAsDataURL(image);
                        reader.onload = e =>{
                            this.setUserAvatar(e.target.result)
                        };
                    })
                    .catch(err => {
                        const errors = {error: err.response.data}
                        if (err.response.status === 422) {
                            this.addValidationErrorToast(errors);
                        } else {
                            this.addErrorToast(errors);
                        }
                    })
            },
            onDeleteImage(){
                this.$axios.post('/api/rest/profile/user/delete-avatar', this.avatar)
                .then((res)=>{
                this.setUserAvatar(null)
                })
                .catch(err => {
                    const errors = {error: err.response.data}
                    if (err.response.status === 422) {
                        this.addValidationErrorToast(errors);
                    } else {
                        this.addErrorToast(errors);
                    }
                })
            }
        },
        computed: {
            ...mapGetters({
                userProfileInfo: 'user/getUserProfileInfo',
                userAvatar: 'user/getUserAvatar'
            }),
            isCurrentUser: function() {
                return this.userProfileInfo.isCurrentUser
            },
            myPublicProfileRoute: function() {
                return USER_PUBLIC_PROFILE(this.currentUserId)
            }
        }
    }
</script>
